export default __webpack_public_path__ + "assets/col-bg-img-1_1col-bg-img-1.1251b250.avif";